export const formatNamedIdentityV815 = (name, id) => {
  const normalizedName = String(name || '').trim();
  const numericID = Number(id) || 0;
  if (normalizedName && numericID > 0)
    return `${normalizedName} (#${numericID})`;
  if (normalizedName) return normalizedName;
  return numericID > 0 ? `#${numericID}` : '-';
};

export const buildVertexDetailCopyTextV815 = (detail) =>
  JSON.stringify(
    {
      request: detail?.request || {},
      attempts: detail?.attempts || [],
      usage_items: detail?.items || [],
    },
    null,
    2
  );
